<template>
  <div id="account">
    <b-container
      class="pt-5"
      fluid
    >
      <b-row class="text-left">
        <b-col>
          <account-nav :menu-selected.sync="subMenuActive" />
        </b-col>
      </b-row>
    </b-container>
    <div class="pt-5">
      <document-component v-if="subMenuActive === 'document'" />
      <stat-view v-if="subMenuActive === 'stat'" />
      <report-view v-if="subMenuActive === 'report'" />
    </div>
    <b-modal
      id="printedDocumentModal"
      ref="printedDocumentModal"
      centered
      hide-footer
      title="สั่งพิมพ์เอกสาร"
      size="lg"
    >
      <document-printed-modal :documents="afterCreate" />
    </b-modal>
  </div>
</template>

<script>
import DocumentComponent from "../../components/Account/DocumentComponent";
import AccountNav from "../../components/Account/AccountNav";
import DocumentPrintedModal from "../../components/Account/DocumentPrintedModal";
import StatView from "../../views/Account/StatView";
import ReportView from "../../views/Account/ReportView"

export default {
    name: "Main",
    components: {
        DocumentComponent,
        AccountNav,
        DocumentPrintedModal,
        StatView,
        ReportView
    },
    props: {
        afterCreate: {
            type: Array
        }
    },
    data() {
        return {
            subMenuActive: "document"
        };
    },
    mounted() {
        if (this.afterCreate) {
            this.$refs.printedDocumentModal.show();
        }
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.sub-menu-btn {
    background-color: transparent;
    border: none;
    color: #2e83d9;
    font-weight: bold;
    & .active {
        background-color: #2e83d9;
    }
}
</style>
